/**
 * HUB-C — Carte paiement Stripe (DS Remobiles).
 */
import React from 'react';
import { CreditCard } from 'lucide-react';
import {
  formatPaymentDate,
  getStripeOrderLabel,
  stripeStatusMeta,
} from '../../utils/paiements/paiementsDisplay';

export default function ActiviteStripePaiementCard({
  payment,
  testIdPrefix = 'activite-paiements',
  compact = false,
}) {
  const badge = stripeStatusMeta(payment.status);
  const id = payment.stripe_session_id || payment.id;

  return (
    <article
      className={`rounded-xl border ${compact ? 'p-3' : 'p-4'}`}
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid={`${testIdPrefix}-stripe-card-${id}`}
    >
      <div className="flex flex-wrap items-center gap-2 mb-2">
        <CreditCard className="w-4 h-4 text-[var(--rm-gray-400)] shrink-0" />
        <span className="font-semibold text-[var(--rm-white)]">{getStripeOrderLabel(payment)}</span>
        <span className={badge.badge}>{badge.label}</span>
        <span className="rm-badge rm-badge--muted">Stripe</span>
      </div>
      <div className={`grid gap-2 text-sm ${compact ? 'grid-cols-1' : 'grid-cols-2 md:grid-cols-3'}`}>
        <div>
          <span className="text-[var(--rm-gray-500)]">Montant : </span>
          <span className="font-bold text-[var(--rm-white)]">{Number(payment.amount || 0).toFixed(2)} €</span>
        </div>
        <div>
          <span className="text-[var(--rm-gray-500)]">Session : </span>
          <span className="text-[var(--rm-gray-300)] font-mono text-xs">{String(id).slice(0, 14)}…</span>
        </div>
        <div>
          <span className="text-[var(--rm-gray-500)]">Date : </span>
          <span className="text-[var(--rm-gray-300)]">{formatPaymentDate(payment.created_at)}</span>
        </div>
      </div>
    </article>
  );
}
